<template>
  <Layout>
    <div class="row" v-if="userData.permissions['new_student'] == 1">
      <div class="row">
        <div class="col-12">
          <div class="d-flex justify-content-between">
            <h4>New Student</h4>
            {{ new Date().toLocaleDateString("en-US", options) }}
          </div>

          <!-- <div class="col-md-6">
              <img :src="photo" style="height:100px;border-radius: 5px" />
            </div> -->
        </div>
        <div class="card shadow-lg mt-2">
          <div class="card-body">
            <div v-if="loader" class="p-5 d-flex justify-content-center">
              <b-spinner variant="primary" style="width: 3rem; height: 3rem;" />
            </div>
            <div v-else>
              <form-wizard
                @on-complete="onComplete()"
                shape="pill"
                back-button-text="Previous"
                next-button-text="Next"
                finish-button-text="Submit"
                color="#ef2c01"
              >
                <tab-content title="Student details" icon="mdi mdi-account">
                  <div class="row">
                    <div class="row">
                      <div class="col-md-6">
                        <vue-web-cam
                          height="100"
                          ref="webcam"
                          :autoplay="true"
                          :selectFirstDevice="selectdev"
                        />
                        <center>
                          <b-button
                            type="button"
                            class="btn btn-sm btn-success"
                            @click="take_photo"
                            ><i class="mdi mdi-camera"></i> Take Photo</b-button
                          >
                        </center>
                      </div>

                      <div class="col-md-6">
                        <img
                          :src="photo"
                          style="height:100px;border-radius: 5px"
                        />
                      </div>
                    </div>

                    <hr />
                    <b-form-group class="col-md-4 mb-1" label="First Name * ">
                      <b-form-input
                        required
                        v-model="firstname"
                        type="text"
                        placeholder="Enter First name"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group class="col-md-4 mb-1" label="Last Name * ">
                      <b-form-input
                        required
                        v-model="lastname"
                        type="text"
                        placeholder="Enter Last name"
                      ></b-form-input>
                    </b-form-group>
                    <div class="col-md-4 mb-1">
                      <label>Gender * </label>
                      <select class="form-control" v-model="gender"
                        ><option>Female</option
                        ><option>Male</option></select
                      >
                    </div>
                    <b-form-group
                      class="col-md-4 mb-1"
                      label="Date of Birth * "
                    >
                      <b-form-input
                        v-model="dob"
                        type="date"
                        :max="currentdate"
                        placeholder="Enter Date of Birth"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group class="col-md-4 mb-1" label="Nationality * ">
                      <v-select
                        :options="countries"
                        placeholder="Enter Nationality"
                        v-model="nationality"
                        label="name"
                        :reduce="(nationality) => nationality.id"
                      ></v-select>
                    </b-form-group>
                    <b-form-group class="col-md-4 mb-1" label="District * ">
                      <b-form-input
                        v-model="district"
                        type="text"
                        placeholder="Enter District * "
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group class="col-md-4 mb-1" label="Address * ">
                      <b-form-input
                        v-model="address"
                        type="text"
                        placeholder="Enter Address "
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group class="col-md-4 mb-1" label="School Pay Code">
                      <b-form-input
                        v-model="school_pay_code"
                        type="number"
                        placeholder="Enter School Pay Code"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      class="col-md-4 mb-1"
                      label="Registration Date * "
                    >
                      <b-form-input
                        v-model="reg_date"
                        type="date"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      class="col-md-4 mb-1"
                      label="Learner Identification Number"
                    >
                      <b-form-input
                        v-model="learnernumber"
                        type="text"
                        placeholder="Enter LIN"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group class="col-md-4 mb-1" label="Card Number">
                      <b-form-input
                        v-model="cardnumber"
                        type="number"
                        placeholder="Enter Card Number"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      class="col-md-4 mb-1"
                      label="Other Identification Number "
                    >
                      <b-form-input
                        v-model="otherid"
                        type="number"
                        placeholder="Enter  Other ID"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                </tab-content>

                <tab-content title="Guardian Details" icon="fas fa-user-tie">
                  <b-button class="btn btn-success mb-3" @click="AddformData"
                    ><i class="mdi mdi-plus"></i> Add Guardian</b-button
                  >
                  <b-button
                    class="btn btn-info mb-3 mx-3"
                    @click="openExistingGuardianModal"
                    ><i class="mdi mdi-plus"></i> Add Existing
                    Guardian</b-button
                  >
                  <form class="repeater mb-5">
                    <div>
                      <div
                        v-for="(parent, index) in parents"
                        :key="parent.id"
                        class="row"
                      >
                        <div class="mb-2 col-md-3">
                          <label>Name * </label>
                          <input
                            v-model="parent.name"
                            type="text"
                            class="form-control"
                          />
                        </div>
                        <div class="mb-2 col-md-2">
                          <label>Gender * </label>
                          <select class="form-control" v-model="parent.gender">
                            <option>Female</option
                            ><option>Male</option>
                          </select>
                        </div>
                        <div class="mb-2 col-md-3">
                          <label>Telephone * </label>
                          <input
                            v-model="parent.telephone"
                            type="number"
                            class="form-control"
                          />
                        </div>
                        <div class="mb-2 col-md-3">
                          <label>Email Address * </label>
                          <input
                            v-model="parent.address"
                            type="email"
                            class="form-control"
                          />
                        </div>
                        <div class="col-md-1 mt-4">
                          <b-button variant="danger" @click="deleteRow(index)"
                            ><i class="fas fa-trash"></i
                          ></b-button>
                        </div>
                      </div>
                    </div>
                  </form>
                </tab-content>
                <tab-content title="Class Information" icon="mdi mdi-school">
                  <div class="row">
                    <b-form-group class="col-md-4 mb-1" label="Term * ">
                      <multiselect
                        v-model="schoolterm"
                        label="name"
                        :options="schoolterms"
                      ></multiselect>
                    </b-form-group>
                    <b-form-group class="col-md-4 mb-1" label="Year * ">
                      <multiselect
                        v-model="year"
                        :options="years"
                      ></multiselect>
                    </b-form-group>
                    <b-form-group class="col-md-4 mb-1" label="Class *">
                      <multiselect
                        v-model="schoolclass"
                        @input="FilterStream"
                        label="name"
                        :options="schoolclasses"
                      ></multiselect>
                    </b-form-group>
                    <b-form-group class="col-md-4 mb-1" label="Stream * ">
                      <multiselect
                        v-model="schoolstream"
                        label="name"
                        :options="schoolstreams"
                      ></multiselect>
                    </b-form-group>
                    <div class="col-md-4 mb-1">
                      <label>Entry Status *</label>
                      <select class="form-control" v-model="entrystatus">
                        <option value="" disabled>Select a Status</option>
                        <option value="New">New</option>
                        <option value="Continuing">Continuing</option>
                      </select>
                    </div>
                    <div class="col-md-4 mb-1">
                      <label>Residential Status *</label>
                      <select class="form-control" v-model="residentialstatus">
                        <option value="" disabled>Select a Status</option>
                        <option value="Boarding">Boarding</option>
                        <option value="Day">Day</option>
                      </select>
                    </div>
                    <div class="col-md-4 mb-1" v-if="schoolclass.level == 1">
                      <label>Combination * </label>
                      <multiselect
                        v-model="combination"
                        :options="combinations"
                        label="comb"
                      ></multiselect>
                    </div>
                  </div>
                </tab-content>
              </form-wizard>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view the Dashboard.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>

    <!-- Modal for selecting existing guardians -->
    <b-modal
      id="existing-parents-modal"
      title="Select Existing Guardian"
      size="lg"
      hide-footer
    >
      <div class="row mb-3">
        <b-form-group>
          <div class="d-flex gap-2">
            <b-form-input
              v-model="searchInput"
              type="text"
              placeholder="Search by full telephone number or email address..."
            ></b-form-input>
            <b-button
              variant="primary"
              @click="searchParent"
              :disabled="!searchInput"
            >
              <i class="mdi mdi-magnify"></i> Search
            </b-button>
          </div>
        </b-form-group>
      </div>

      <div v-if="searchResult" class="mt-3">
        <b-table
          striped
          hover
          :items="[searchResult]"
          :fields="parentTableFields"
          responsive
        >
          <template #cell(actions)="row">
            <b-button
              size="sm"
              variant="success"
              @click="addExistingParent(row.item)"
              :disabled="isParentAlreadyAdded(row.item.id)"
            >
              {{
                isParentAlreadyAdded(row.item.id) ? "Already Added" : "Select"
              }}
            </b-button>
          </template>
        </b-table>
      </div>

      <div v-else-if="searched && !searchResult" class="mt-3">
        <b-alert variant="warning" show>
          No parent found with the provided telephone or email address.
        </b-alert>
      </div>

      <div class="mt-3 text-right">
        <b-button variant="secondary" @click="closeModal">Close</b-button>
      </div>
    </b-modal>
  </Layout>
</template>

<script>
import appConfig from "@/app.config";
import {
  combinationsComputed,
  combinationsMethods,
  countriesComputed,
  countriesMethods,
  schoolclassComputed,
  schoolclassMethods,
  schooltermComputed,
  schooltermMethods,
} from "@/state/helpers";
import axios from "axios";
import { FormWizard, TabContent } from "vue-form-wizard";
import Multiselect from "vue-multiselect";
import { WebCam } from "vue-web-cam";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "New Student ",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Multiselect,
    FormWizard,
    TabContent,
    "vue-web-cam": WebCam,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      options: {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      },
      currentdate: new Date().toLocaleDateString("fr-CA"),
      firstname: "",
      lastname: "",
      nationality: "",
      district: "",
      gender: "Male",
      address: "",
      dob: new Date().toLocaleDateString("fr-CA"),
      reg_date: new Date().toLocaleDateString("fr-CA"),
      school_pay_code: "",
      parents: [],
      schoolclass: "",
      schoolstreams: [],
      schoolstream: "",
      schoolterm: "",
      year: new Date().getFullYear(),
      entrystatus: "",
      residentialstatus: "",
      learnernumber: "",
      cardnumber: "",
      loader: false,
      photo: null,
      studentphoto: "",
      selectdev: true,
      otherid: "",
      combination: "",
      existingParents: [],
      searchInput: "",
      searchResult: null,
      searched: false,
      loadingParents: false,
      parentTableFields: [
        { key: "name", label: "Name" },
        { key: "gender", label: "Gender" },
        { key: "actions", label: "Action" },
      ],
    };
  },
  created() {
    this.fetchCountries();
    this.fetchCombinations();
    this.nationality = this.countries.find(
      (option) => (option.name = "Uganda"),
    );
    this.fetchSchoolClasses();
    this.fetchSchoolTerms();
  },
  mounted() {
    this.nationality = this.countries.find((option) => option.name == "Uganda");
    this.schoolterm = this.schoolterms.find((option) => option.active == 1);
  },
  computed: {
    ...combinationsComputed,
    ...countriesComputed,
    ...schoolclassComputed,
    ...schooltermComputed,
    years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {
        yearArray.push(year);
      }
      return yearArray;
    },
  },
  methods: {
    ...combinationsMethods,
    ...countriesMethods,
    ...schoolclassMethods,
    ...schooltermMethods,

    async onComplete() {
      this.loader = true;

      let parentsData = [];

      for (let parent of this.parents) {
        if (parent.existing && parent.id) {
          parentsData.push({
            id: parent.id,
            name: parent.name,
            gender: parent.gender,
            telephone: parent.telephone,
            address: parent.address,
            existing: true,
          });
        } else {
          parentsData.push({
            name: parent.name,
            gender: parent.gender,
            telephone: parent.telephone,
            address: parent.address,
          });
        }
      }
      let obj = {
        first_name: this.firstname,
        last_name: this.lastname,
        gender: this.gender,
        date_of_birth: this.dob,
        nationality: this.nationality.id,
        district: this.district,
        address: this.address,
        school_pay_code: this.school_pay_code,
        reg_date: this.reg_date,
        parents: parentsData,
        schoolterm: this.schoolterm.id,
        year: this.year,
        schoolclass: this.schoolclass.id,
        schoolstream: this.schoolstream.id,
        entrystatus: this.entrystatus,
        residentialstatus: this.residentialstatus,
        learnernumber: this.learnernumber,
        cardnumber: this.cardnumber,
        otherid: this.otherid,
        combination: this.combination.comb,
      };

      let url = "/savestudentdata";
      await axios
        .post(url, obj)
        .then((response) => {
          if (response.status == 200) {
            this.$swal({
              title: "Success",
              text: response.data.message,
              icon: "success",
            });
            this.$router.push({ name: "viewstudents" });
            this.loader = false;
          }
        })
        .catch((error) => {
          this.loader = false;
          this.$swal({
            title: "Error",
            text: error.response?.data?.message,
            icon: "error",
          });
        });
    },

    async FilterStream() {
      let url = `/findschoolstream/${this.schoolclass.id}`;
      await axios.get(url).then((response) => {
        this.schoolstreams = response.data.streams;
      });
    },
    AddformData() {
      this.parents.push({ name: "", gender: "", telephone: "", address: "" });
    },
    deleteRow(index) {
      if (confirm("Are you sure you want to delete this element?"))
        this.parents.splice(index, 1);
    },
    async take_photo() {
      const image = await this.$refs.webcam.capture();
      this.photo = image;
      const binaryData = this.convertBase64ToBinary(image);
      this.saveBinary(binaryData);
    },

    convertBase64ToBinary(base64String) {
      const byteString = atob(base64String.split(",")[1]);

      const byteNumbers = new Array(byteString.length);

      for (let i = 0; i < byteString.length; i++) {
        byteNumbers[i] = byteString.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      return byteArray;
    },

    saveBinary(binaryData) {
      const blob = new Blob([binaryData], { type: "image/jpeg" });

      this.studentphoto = blob;
    },
    async openExistingGuardianModal() {
      this.loadingParents = true;
      this.searchInput = "";
      this.searchResult = null;
      this.searched = false;

      try {
        const response = await axios.get("/getexistingparents");
        this.existingParents = response.data.parents || [];
        this.$bvModal.show("existing-parents-modal");
      } catch (error) {
        this.$swal({
          title: "Error",
          text: "Failed to load existing guardians. Please try again.",
          icon: "error",
        });
      } finally {
        this.loadingParents = false;
      }
    },

    searchParent() {
      if (!this.searchInput || !this.searchInput.trim()) {
        this.$swal({
          title: "Input Required",
          text: "Please enter a telephone number or email address to search.",
          icon: "warning",
          timer: 2000,
        });
        return;
      }

      const searchValue = this.searchInput.trim();
      this.searched = true;
      this.searchResult = null;

      const foundParent = this.existingParents.find((parent) => {
        const telephoneMatch =
          parent.telephone && parent.telephone.toString() === searchValue;

        const emailMatch =
          parent.address &&
          parent.address.toLowerCase() === searchValue.toLowerCase();

        return telephoneMatch || emailMatch;
      });

      if (foundParent) {
        this.searchResult = foundParent;
      } else {
        this.searchResult = null;
      }
    },

    isParentAlreadyAdded(parentId) {
      return this.parents.some((parent) => parent.id === parentId);
    },

    addExistingParent(parent) {
      if (this.isParentAlreadyAdded(parent.id)) {
        this.$swal({
          title: "Already Added",
          text: `${parent.name} is already in the parents/guardians list`,
          icon: "warning",
          timer: 2000,
        });
        return;
      }

      this.parents.push({
        id: parent.id,
        name: parent.name,
        gender: parent.gender,
        telephone: parent.telephone,
        address: parent.address || parent.email,
        existing: true,
      });

      this.closeModal();
    },

    closeModal() {
      this.$bvModal.hide("existing-parents-modal");
      this.searchInput = "";
      this.searchResult = null;
      this.searched = false;
    },
  },
};
</script>
